import { Button, Divider } from '@material-ui/core';
import React, { useState } from 'react';
import moment from 'moment';
import { KpiGlobalUser } from 'generated/graphql';

export interface ActivitiesProps {
  activities: {
    date?: moment.Moment;
    user?: KpiGlobalUser | null;
    action: string;
  }[];
}

export const Activities: React.FC<ActivitiesProps> = ({ activities }) => {
  const [isViewMore, setIsViewMore] = useState(false);
  return (
    <div className="p-4" style={{ backgroundColor: 'white', minWidth: 386 }}>
      <h3 className="pb-2" style={{ minHeight: 48 }}>
        Activities
      </h3>
      <Divider />
      <ul
        className="pt-0 pr-0"
        style={{
          maxHeight: isViewMore ? 'initial' : 277,
          overflow: 'auto',
          paddingLeft: 18,
        }}
      >
        {activities.map((e, i) => (
          <li key={i}>
            {e.action + ' '}
            {e.user && `by ${e.user.firstName} ${e.user.lastName} `}
            {e.date?.format('LLLL')}
          </li>
        ))}
      </ul>
      {activities?.length === 0 && (
        <p className="text-center">No updates yet.</p>
      )}
      {activities?.length > 6 && (
        <Button
          className="mb-3"
          color="primary"
          onClick={() => setIsViewMore(!isViewMore)}
        >
          View {isViewMore ? 'Less' : 'More'}
        </Button>
      )}
    </div>
  );
};
